import type { OrganizationId, Organization, UserId } from "@/types";
import axios from "axios";

// @ts-expect-error import.meta.env will be available
const endpoint = import.meta.env.VITE_BIRDHOUSE_ENDPOINT;

export async function listOrganizations(): Promise<Organization[]> {
  return (await axios.get(endpoint + "/organizations")).data.organizations;
}

export function addOrganization(data) {
  return axios.post(endpoint + "/organizations", JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
}

export async function getOrganization(
  id: OrganizationId
): Promise<Organization> {
  return (await axios.get(endpoint + "/organizations/" + id)).data;
}

export function updateOrganization(id: OrganizationId, data) {
  return axios.patch(endpoint + "/organizations/" + id, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
}

export function setOrganizationReviewer(
  id: OrganizationId,
  reviewerId: UserId
) {
  return axios.put(
    `${endpoint}/organizations/${id}/reviewer`,
    JSON.stringify({ reviewer_id: reviewerId }),
    { headers: { "Content-Type": "application/json" } }
  );
}

export function deleteOrganization(id) {
  return axios.delete(endpoint + "/organizations/" + id);
}

function useOrganizationsAPI() {
  return {
    listOrganizations,
    addOrganization,
    getOrganization,
    updateOrganization,
    deleteOrganization,
  };
}

export default useOrganizationsAPI;
